<template>
    <div class="down-box" v-if="lectoParams.LectotypeParams.length > 0 || lectoParams.IsSelected">

        <div style="display: flex;" v-if="isTianzhunPlugin">
          <div
            class="down-btn button-view"
            :class="isStepDown ? '' : 'disable'"
            @click="stepDownStart(2)"
            v-if="!docDetail"
          >下载</div>
          <div
              class="open-btn button-view"
              :class="isStepDown ? '' : 'disable'"
              @click="stepDownStart(1)"
              v-if="!docDetail"
          >打开</div>

          <btn-doc-down :doc="docDetail" downText="下载" :is-save="false" @docDown="(downUrl) => docDown(2, downUrl)" v-if="docDetail"></btn-doc-down>
          <btn-doc-down :doc="docDetail" downText="打开" :is-save="false" @docDown="(downUrl) => docDown(1, downUrl)" v-if="docDetail"></btn-doc-down>
        </div>

        <div style="display: flex;" v-if="isTianzhunAdmin">
          <div
            class="down-btn button-view"
            :class="isStepDown ? '' : 'disable'"
            @click="stepDownStart(3)"
            v-if="!docDetail"
          >添加到海选库</div>
          <btn-doc-down :doc="docDetail" downText="添加到海选库" :is-save="false" @docDown="(downUrl) => docDown(3, downUrl)" v-if="docDetail"></btn-doc-down>
        </div>
  
      <!-- 图纸 -->
      <!-- <btn-doc-down :doc="docDetail" downText="下载通用模型" v-if="docDetail"></btn-doc-down> -->
    </div>
  </template>
  
<script>
  import {Loading} from 'element-ui'
  import { DscStorageLib, UserService as ModuleUserService } from '@digital-supply-chain/module'
  import { ApiService, AuthService, ProductService } from '@/service';
  import Event, {EventEnum} from '@/EventEmeitter'
  import { UtilService, IframePostMessage, ProductSelectionNotice } from '@/libs';

  import { download, formatBzjName } from './lectoParamsDown';

  import BtnDocDown from './components/BtnDocDown.vue';
  
  export default {
    data() {
      return {
        downOption: {},
        isLoading: false,
        downType: 1,
        isTianzhunPlugin: DscStorageLib.sessionGet(IframePostMessage.NeIframeAgent).type == IframePostMessage.NeIframeAgentTianZhunPlugin,
        isTianzhunAdmin: DscStorageLib.sessionGet(IframePostMessage.NeIframeAgent).type == IframePostMessage.NeIframeAgentTianZhunAdmin,
      }
    },
    inject: ['productDocs','downLoadCheck'],
    props: {
      lectoParams: { default: {} },
      lectoProId: { default: 0 },
      productDetail: { default: {} },
      checkParams: { default: {} },
    },
    mounted() {
        UtilService.GetIframeAgent().then(data => {
          this.iframeType = data.type;
        })
    },
    components: { BtnDocDown },
    computed: {
      docDetail() {
        let findOne = null;
        this.productDocs.forEach(docs => {
          if(this.lectoParams.SkuName && docs.FileName.toLowerCase()  == this.lectoParams.SkuName.toLowerCase() ) {
            findOne = docs;
          }
        });
        return findOne;
      },
      // 模型是否可下载
      isStepDown() {
        let hasStepMx = false;
        const { IsSeries, IsSelected, StepFileServerPath, ModelFileServerPath } = this.lectoParams;
        if (IsSeries || (this.productDetail.HasModel == 2)) {
          if(StepFileServerPath && IsSelected) {
            hasStepMx = true;
          }
        } else {
          if(ModelFileServerPath || StepFileServerPath && IsSelected) {
            hasStepMx = true;
          }
        }
        return hasStepMx
      }
    },
    methods: {
      stepDownStart(downType) {
        this.downType = downType;
        this.downLoadCheck(() => {
          this.stepFileExtDown();
        })
      },

      
      // 下载模型
      async stepFileExtDown(isExist = false) {
        const { ModelFileServerPath, StepFileName, StepFileServerPath } = this.lectoParams;
        if (!this.isStepDown) return;
        const url = `${ApiService.JrzzApi}/${ModelFileServerPath}/1?token=${AuthService.token(false)}&fileName=${encodeURI(StepFileName)}`;
        if (!StepFileServerPath && !isExist) {
          this.BuildStepFile();
        }
        const checkStep = await this.stepFileExist();
        if (!checkStep) {
            this.fullLoading = Loading.service({
                lock: true,
                customClass: 'lecto-params-down-loading',
                text: '模型生成中，请您耐心等待...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            setTimeout(() => {
                this.stepFileExtDown(true);
            }, 3000)
            return false;
        }
        this.fullLoading && this.fullLoading.close();
        this._down_load_file(
          url,
          'step_file',
          isExist,
        );
      },

      async stepFileExist() {
        const { StepFileName } = this.lectoParams;
        const { ProdID } = this.productDetail;
        return await ProductService.stepFileExist(ProdID, 1, StepFileName);
      },
      // 通知服务端进行模型构建
      BuildStepFile() {
        if (!this.lectoParams.SkuName) return false;
        const SelConfigs = this.lectoParams.LectotypeParams.map(item => ({ ID: item.ID, Value: item.Value }));
        ProductService.SaveStepJson(this.lectoParams.SkuName, this.lectoProId, SelConfigs);
      },

      docDown(downType, downUrl) {
        this.downType = downType;
        if (this.downType == 3) {
          this.$emit('noticeParentMessage', ProductSelectionNotice.LectoAddToLibrary)
        } else {
          const {ProdID} = this.productDetail;
          const {SkuName} = this.lectoParams;
          const prodid = this.lectoProId || ProdID;
          console.log({
            prodid,
            skuname: SkuName,
            type: this.downType,
            url: downUrl
          })
          window.formium.postMessage("OpenModel", {
            prodid,
            skuname: SkuName,
            type: this.downType,
            url: downUrl
          });
        }
      },

      // 文件下载
      async _down_load_file( url = '', file_type = '', isExist = false) {
        if (!ModuleUserService.token()) {
          Event.emit(EventEnum.LOGIN_OPEN);
          return false;
        }
        let fileName = '';
        if (this.productDetail.CompID == 0) {
          fileName = formatBzjName(this.productDetail.ProdName, this.productDetail.PromoteName, this.lectoParams.SkuName, this.lectoParams);
        } else {
          fileName = UtilService.SpecialCharacter(`${this.productDetail.ProdName}[${this.lectoParams.SkuName}]`);
        }
        const file_ext = file_type === 'model_file' ? this.lectoParams.ModelFileExt : 'step';
        let savePath = fileName + '.' + file_ext; 
        this.downOption = download(savePath, file_type, this.lectoParams, this.productDetail, this.IsAddToCurrentAssembly, this.lectoProId);
        console.log(this.downOption);

        const {downUrl,downloadArgs} = this.downOption;
        if (this.downType == 3) {
          this.$emit('noticeParentMessage', ProductSelectionNotice.LectoAddToLibrary)
        } else {
          window.formium.postMessage("OpenModel", {
            prodid: downloadArgs.ProdID,
            skuname: downloadArgs.SkuName,
            type: this.downType,
            url: downUrl
          });
        }
      },
    }
  }
</script>
  
  <style lang="less">
    .lecto-params-down-loading{
        .el-loading-spinner .el-loading-text{
            color: #ffffff;
            font-size: 16px;
            margin-top: 8px;
        }
        .el-icon-loading{
            font-size: 50px;
            color: #ffffff;
        }
    }
</style>

  <style lang="less" scoped>
  .set-icon{
    position: absolute;
    right: 7px;
    top: 7px;
    width: 26px;
    height: 26px;
    font-size: 20px;
    color: #606266;
    cursor: pointer;
    text-align: center;
    line-height: 25px;
  }
  .down-box{
    width: 100%;
    height: 42px;
    background: #F1F1F1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    position: relative;
    .button-view.disable{
        border: 1px solid #ccc;
      background: #ccc;
      cursor: not-allowed;
      color: #ffffff;
    }
  
    /deep/ .doc-download{
      width: 100px;
      height: 30px;
      background: #ffffff;
      border: 1px solid @main-color;
      border-radius: 4px;
      color: @main-color;
    }
    /deep/ .doc-download:first-child{
      margin-right: 24px;
      background: @main-color;
      border: 1px solid @main-color;
      color: #ffffff;
    }
  }
  .down-btn{
    width: 100px;
    height: 30px;
    background: @main-color;
    border: 1px solid @main-color;
    border-radius: 4px;
    text-align: center;
    line-height: 28px;
    color: #ffffff;
    cursor: pointer;
    margin-right: 24px;
  }
  .open-btn{
    width: 100px;
    height: 30px;
    background: #ffffff;
    border: 1px solid @main-color;
    border-radius: 4px;
    text-align: center;
    line-height: 28px;
    color: @main-color;
    cursor: pointer;
  }
  .down-view{
    width: 100px;
    height: 30px;
  }
  .down-view{
    background: #ccc;
    cursor: not-allowed;
    position: relative;
    text-align: center;
    line-height: 30px;
    color: #ffffff;
    border-radius: 4px;
    overflow: hidden;
    &.open{
      cursor: pointer;
    }
    &>div{
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }
    &>span{
      position: relative;
      z-index: 2;
    }
  }
  </style>
  